import { dmApi } from "../dmApi";
import { getAuthorizationHeader } from "../../helpers/RtkQueryUtils";
import { handleQueryErrorAndSuccess } from "../../helpers/RtkQueryUtils";
const userApi = dmApi.injectEndpoints({
  endpoints: (build) => ({
    getUsers: build.query({
      query: ({ page = 1, limit = 10, search }) => ({
        url: `/admin/get-users?page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
        headers: getAuthorizationHeader()
      }),
      providesTags:["UsersApi"]
    }),
    getOdoUsers: build.query({
      query: ({ page = 1, limit = 10, search }) => ({
        url: `/admin/get-odoo-leads?page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
        headers: getAuthorizationHeader()
      })
    }),
    changePassword: build.mutation({
      query: (data) => ({
        url: "/admin/change-password",
        method: "POST", // or "POST" based on backend
        body: data,
        headers: getAuthorizationHeader(),
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', 'Password changed successfully');
      },
    }),
    enableReview: build.mutation({
      query: (userId) => ({
        url: `/admin/enable-reviews?userId=${userId}`,
        method: "PUT",
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags:["UsersApi"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', 'Review enable status changed');
      },
    }),
    help: build.mutation({
      query: (data) => ({
        url: "admin/create-update-help",
        method: "POST", // or "POST" based on backend
        body: data,
        headers: getAuthorizationHeader(),
      }),
    }),
    getHelpRequests: build.query({
      query: () => ({
        url: '/admin/get-help',
        method: 'GET',
        headers: getAuthorizationHeader(), // if you have auth headers
      }),
    }),
    getQuoteTrackingAnalytics: build.query({
      query: ({from,to}) => ({
        url: `/admin/get-quote-website-user-tracking-analytics?from=${from}&to=${to}`,
        method: 'GET',
        headers: getAuthorizationHeader(), // if you have auth headers
      }),
    }),
    getTrackedUsersDetails: build.query({
      query: ({ page = 1, limit = 10, search = '', startDate, endDate }) => ({
        url: `/admin/get-tracked-users-details?page=${page}&limit=${limit}&search=${search}&startDate=${startDate}&endDate=${endDate}`,
        method: 'GET',
        headers: getAuthorizationHeader(),
      }),
    }),
    getTrackedUserDetailsById: build.query({
      query: ({ id }) => ({
        url: `/admin/get-tracked-user-details-by-id?id=${id}`,
        method: 'GET',
        headers: getAuthorizationHeader(),
      }),
    }),
    getAssignedSurveys: build.query({
      query: ({ userId, leadId, page = 1, limit = 10, search }) => ({
        url: `/admin/get-assigned-surveys?userId=${userId}&leadId=${leadId}&search=${search}&page=${page}&limit=${limit}`,
        method: 'GET',
        headers: getAuthorizationHeader(),
      }),
      providesTags: ['AssignedSurveys'],
    }),
    getUserAccounts: build.query({
      query: ({email }) => ({
        url: `/admin/get-user-all-accounts?email=${email}`,
        method: 'GET',
        headers: getAuthorizationHeader(),
      }),
    }),
    getContactTimings: build.query({
      query: () => ({
        url: '/admin/get-contact-timings',
        method: 'GET',
        headers: getAuthorizationHeader(),
      }),
      providesTags: ['ContactTimings'],
    }),
    addContactTimings: build.mutation({
      query: (data) => ({
        url: '/admin/add-contact-timings',
        method: 'POST',
        body: data,
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags: ['ContactTimings'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', 'Contact timings updated successfully');
      },
    }),
    listIPs: build.query({
      query: () => ({
        url: '/admin/list-ips',
        method: 'GET',
        headers: getAuthorizationHeader(),
      }),
      providesTags: ['IgnoreIPs'],
    }),
    addIP: build.mutation({
      query: (data) => ({
        url: '/admin/add-ip',
        method: 'POST',
        body: data,
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags: ['IgnoreIPs'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', 'IP added successfully');
      },
    }),
    deleteIP: build.mutation({
      query: (id) => ({
        url: `/admin/delete-ip/${id}`,
        method: 'DELETE',
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags: ['IgnoreIPs'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, '', 'IP deleted successfully');
      },
    }),
  })
});

export const { useGetUsersQuery, useGetOdoUsersQuery, useChangePasswordMutation, useEnableReviewMutation, useHelpMutation, useGetAssignedSurveysQuery, useGetHelpRequestsQuery,useGetUserAccountsQuery, useGetQuoteTrackingAnalyticsQuery, useGetTrackedUsersDetailsQuery, useGetTrackedUserDetailsByIdQuery, useGetContactTimingsQuery, useAddContactTimingsMutation, useListIPsQuery, useAddIPMutation, useDeleteIPMutation } = userApi;
